import React from 'react';

// Table ordering: Material Icons "restaurant" (fork and knife, Google, Apache License 2.0).
export default function CutleryIcon({ className, color }) {
  return (
    <svg
      className={className ?? 'h-10 w-10'}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z"
        fill={color ?? 'white'}
      />
    </svg>
  );
}
